import React, { useEffect, useState } from 'react';
import { Card, PageHeader, Button, Badge, Input } from '../../components/shared/ui';
import { adminAPI, extendedAdminAPI as adminAPI2 } from '../../utils/api';

const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5001/api').replace('/api', '');

const AdminCompanies = () => {
  const [companies, setCompanies] = useState([]);
  const [filter, setFilter] = useState('all');
  const [selected, setSelected] = useState(new Set());
  const [detail, setDetail] = useState(null);
  const [rejectModal, setRejectModal] = useState(null);
  const [rejectReason, setRejectReason] = useState('');
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  const load = (f = filter) => {
    setLoading(true);
    const params = f === 'pending' ? { approved:'false' } : f === 'approved' ? { approved:'true' } : f === 'rejected' ? { approved:'rejected' } : {};
    adminAPI.getCompanies(params).then(r => setCompanies(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const flash = (msg) => { setMessage(msg); setTimeout(() => setMessage(''), 3500); };
  const handleApprove = async (id) => { await adminAPI.approveCompany(id); load(); flash('Şirket onaylandı ve e-posta gönderildi.'); };
  const handleReject = async () => {
    try {
      await adminAPI2.rejectCompany(rejectModal.id, rejectReason);
      setRejectModal(null);
      setRejectReason('');
      load();
      flash('Şirket reddedildi.');
    } catch (err) {
      const msg = err?.response?.data?.error || 'Red işlemi başarısız.';
      flash('Hata: ' + msg);
    }
  };
  const handleBulkApprove = async () => { if (!selected.size) return; await adminAPI2.bulkApproveCompanies([...selected]); setSelected(new Set()); load(); flash(`${selected.size} şirket onaylandı.`); };
  const handleDeleteLogo = async (id) => {
    if (!window.confirm('Bu şirketin logosu silinecek. Emin misiniz?')) return;
    try {
      await adminAPI2.deleteCompanyLogo(id);
      setDetail(d => d ? { ...d, logo_url: null } : d);
      flash('Logo silindi.');
    } catch (err) {
      flash('Hata: ' + (err?.response?.data?.error || 'Logo silinemedi.'));
    }
  };
  const toggleSelect = (id) => setSelected(s => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const toggleAll = () => setSelected(s => s.size === companies.length ? new Set() : new Set(companies.map(c => c.id)));

  return (
    <>
      <PageHeader title="Şirket Yönetimi" description="Şirket başvurularını onayla, reddet veya detaylarını incele" />

      {message && (
        <div style={{ position: 'fixed', bottom: 80, right: 24, zIndex: 9999, padding: '12px 20px', borderRadius: 10, fontWeight: 600, fontSize: 14, boxShadow: '0 4px 16px rgba(0,0,0,0.15)', background: message.startsWith('Hata') ? '#fef2f2' : '#f0fdf4', color: message.startsWith('Hata') ? '#dc2626' : '#16a34a', border: `1px solid ${message.startsWith('Hata') ? '#fca5a5' : '#86efac'}` }}>
          {message.startsWith('Hata') ? '✗ ' : '✓ '}{message}
        </div>
      )}

      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
        <div className="flex flex-wrap gap-2">
          {[['all','Tümü'],['pending','Onay Bekleyen'],['approved','Onaylı'],['rejected','Reddedildi']].map(([v,l]) => (
            <button key={v} onClick={() => { setFilter(v); load(v); setSelected(new Set()); }}
              className={`px-4 py-1.5 rounded-full text-sm border transition-colors ${filter===v ? 'border-brand-700 bg-brand-50 text-brand-700 font-medium' : 'border-ink-200 bg-white text-ink-700 hover:bg-ink-50'}`}>
              {l}
            </button>
          ))}
        </div>
        {selected.size > 0 && <Button onClick={handleBulkApprove} className="!bg-emerald-600 hover:!bg-emerald-700">{selected.size} Şirketi Onayla</Button>}
      </div>

      <Card padded={false}>
        {/* Desktop tablo */}
        <div className="hidden md:block">
          <div className="grid grid-cols-[40px_1fr_140px_120px_110px_180px] px-4 py-2.5 bg-ink-50 border-b border-ink-200 text-xs font-semibold text-ink-600">
            <input type="checkbox" checked={selected.size === companies.length && companies.length > 0} onChange={toggleAll} />
            <span>Şirket</span><span>Sektör</span><span>Şehir</span><span>Durum</span><span>İşlemler</span>
          </div>
          {loading ? <div className="p-8 text-center text-ink-400">Yükleniyor...</div>
           : companies.length === 0 ? <div className="p-8 text-center text-ink-400">Şirket bulunamadı.</div>
           : companies.map(c => (
            <div key={c.id} className={`grid grid-cols-[40px_1fr_140px_120px_110px_180px] px-4 py-3 border-b border-ink-100 items-center ${selected.has(c.id) ? 'bg-brand-50/50' : ''}`}>
              <input type="checkbox" checked={selected.has(c.id)} onChange={() => toggleSelect(c.id)} />
              <div className="min-w-0">
                <div className="font-medium text-sm text-ink-900 truncate">{c.name}</div>
                <div className="text-xs text-ink-400 truncate">{c.email}</div>
              </div>
              <div className="text-sm text-ink-600 truncate">{c.sector || '—'}</div>
              <div className="text-sm text-ink-600 truncate">{c.city || '—'}</div>
              <div><Badge tone={c.is_approved ? 'green' : (!c.is_active ? 'red' : 'amber')}>{c.is_approved ? 'Onaylı' : (!c.is_active ? 'Reddedildi' : 'Bekliyor')}</Badge></div>
              <div className="flex flex-wrap gap-1.5">
                <button onClick={() => adminAPI2.getCompanyDetail(c.id).then(r => setDetail(r.data))} className="px-2.5 py-1 text-xs border border-ink-200 rounded-md hover:bg-ink-50 text-ink-700">Detay</button>
                {!c.is_approved && c.is_active && (<>
                  <button onClick={() => handleApprove(c.id)} className="px-2.5 py-1 text-xs bg-emerald-600 text-white rounded-md hover:bg-emerald-700">Onayla</button>
                  <button onClick={() => setRejectModal({ id:c.id, name:c.name })} className="px-2.5 py-1 text-xs bg-red-600 text-white rounded-md hover:bg-red-700">Reddet</button>
                </>)}
              </div>
            </div>
          ))}
        </div>

        {/* Mobile kart liste */}
        <div className="md:hidden divide-y divide-ink-100">
          {loading ? <div className="p-6 text-center text-ink-400">Yükleniyor...</div>
           : companies.length === 0 ? <div className="p-6 text-center text-ink-400">Şirket bulunamadı.</div>
           : companies.map(c => (
            <div key={c.id} className="p-3">
              <div className="flex items-start gap-2">
                <input type="checkbox" className="mt-1" checked={selected.has(c.id)} onChange={() => toggleSelect(c.id)} />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <div className="font-medium text-sm text-ink-900 truncate">{c.name}</div>
                    <Badge tone={c.is_approved ? 'green' : (!c.is_active ? 'red' : 'amber')}>{c.is_approved ? 'Onaylı' : (!c.is_active ? 'Reddedildi' : 'Bekliyor')}</Badge>
                  </div>
                  <div className="text-xs text-ink-500 truncate">{c.email}</div>
                  <div className="text-xs text-ink-500 truncate">{c.sector || '—'} {c.city ? '· '+c.city : ''}</div>
                  <div className="flex flex-wrap gap-1.5 mt-2">
                    <button onClick={() => adminAPI2.getCompanyDetail(c.id).then(r => setDetail(r.data))} className="px-2.5 py-1 text-xs border border-ink-200 rounded-md text-ink-700">Detay</button>
                    {!c.is_approved && c.is_active && (<>
                      <button onClick={() => handleApprove(c.id)} className="px-2.5 py-1 text-xs bg-emerald-600 text-white rounded-md">Onayla</button>
                      <button onClick={() => setRejectModal({ id:c.id, name:c.name })} className="px-2.5 py-1 text-xs bg-red-600 text-white rounded-md">Reddet</button>
                    </>)}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Card>

      {rejectModal && (
        <div className="fixed inset-0 bg-ink-900/50 flex items-center justify-center z-50 p-4">
          <Card className="w-full max-w-md">
            <h2 className="text-base font-semibold text-ink-900 mb-1">Şirketi Reddet</h2>
            <p className="text-sm text-ink-500 mb-4"><strong>{rejectModal.name}</strong> reddedilecek. Şirkete bildirim e-postası gönderilecektir.</p>
            <label className="block text-sm font-medium text-ink-700 mb-1">Red gerekçesi (isteğe bağlı)</label>
            <textarea rows={3} className="input resize-y" value={rejectReason} onChange={e => setRejectReason(e.target.value)} placeholder="Eksik belge, uygunsuz içerik vb." />
            <div className="flex gap-2 mt-4">
              <Button variant="danger" onClick={handleReject}>Reddet</Button>
              <Button variant="secondary" onClick={() => setRejectModal(null)}>İptal</Button>
            </div>
          </Card>
        </div>
      )}

      {detail && (
        <div className="fixed inset-0 bg-ink-900/50 flex items-center justify-center z-50 p-4">
          <Card className="w-full max-w-lg max-h-[85vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-lg font-bold text-ink-900">{detail.name}</h2>
              <button onClick={() => setDetail(null)} className="text-2xl text-ink-500 leading-none w-8 h-8 flex items-center justify-center rounded-full hover:bg-ink-100">×</button>
            </div>

            {/* Şirket logosu + silme */}
            <div className="flex items-center gap-3 py-3 mb-1 border-b border-ink-100">
              <div className="w-16 h-16 rounded-lg border border-ink-200 bg-ink-50 flex items-center justify-center overflow-hidden flex-shrink-0">
                {detail.logo_url
                  ? <img src={`${API_BASE}${detail.logo_url}`} alt="logo" className="w-full h-full object-cover" />
                  : <span className="text-xs text-ink-400">Logo yok</span>}
              </div>
              <div>
                <div className="text-xs text-ink-400 mb-1">Şirket Logosu</div>
                {detail.logo_url
                  ? <button onClick={() => handleDeleteLogo(detail.id)} className="px-2.5 py-1 text-xs bg-red-600 text-white rounded-md hover:bg-red-700">Logoyu Sil</button>
                  : <span className="text-sm text-ink-500">Yüklenmemiş</span>}
              </div>
            </div>

            {[['E-posta',detail.email],['Sektör',detail.sector],['Şehir',detail.city],['Çalışan',detail.employee_count],['Web',detail.website],['Kayıt',detail.registered_at && new Date(detail.registered_at).toLocaleDateString('tr-TR')]].map(([k,v]) => v ? (
              <div key={k} className="flex gap-3 py-2 border-b border-ink-100">
                <span className="text-xs text-ink-400 w-24 flex-shrink-0">{k}</span>
                <span className="text-sm text-ink-900 break-words">{v}</span>
              </div>
            ) : null)}
            {detail.description && <div className="py-3"><div className="text-xs text-ink-400 mb-1">Açıklama</div><p className="text-sm text-ink-700">{detail.description}</p></div>}
            {detail.positions?.length > 0 && (
              <div className="mt-3">
                <div className="text-sm font-medium text-ink-700 mb-2">İlanlar ({detail.positions.length})</div>
                {detail.positions.map(p => (
                  <div key={p.id} className="flex justify-between text-sm text-ink-600 py-1">
                    <span>{p.title}</span><span>{p.match_count} eşleşme</span>
                  </div>
                ))}
              </div>
            )}
            {!detail.is_approved && (
              <div className="flex gap-2 mt-5">
                <Button onClick={() => { handleApprove(detail.id); setDetail(null); }} className="!bg-emerald-600 hover:!bg-emerald-700">Onayla</Button>
                <Button variant="danger" onClick={() => { setDetail(null); setRejectModal({ id:detail.id, name:detail.name }); }}>Reddet</Button>
              </div>
            )}
          </Card>
        </div>
      )}
    </>
  );
};

export default AdminCompanies;
